import { IOption, IModule, IIncompatibleModule } from "./Interface";
import { IValidationResult } from "../Stores/ProductConfigurationStore";
import { uniqBy } from "lodash";


export function canSelectOptionInSelection(option: IOption, selection: { [id: string]: IModule[] }, optionsField: (module: IModule) => IOption[] | undefined) {

	let validationResult: IValidationResult = {
		valid: true,
		reason: {
			modules: [],
		}
	}

	for (var key in selection) {
		selection[key].forEach(module => {
			const options = optionsField(module)
			if (options && options?.length > 0) { // check this module if it has rowWidths defined
				const result = options.find(o => o.id === option.id) // check if the selected module has the hiven option
				if (!result) {
					validationResult.valid = false; // flag as invalid
					validationResult.reason.modules.push(module) // remember why this option can´t be picked
					return false;
				} else {
					return true;
				}
			}
		});
	}
	return validationResult;
}

export function canSelectModuleWithIdInSelections(moduleId: string, selections: { [id: string]: {id: string, content?: string, moduleFields?: { mrIncompatible?: IIncompatibleModule[]}}[]}[], skipIds?: string[]) {
	let validationResult: IValidationResult = {
		valid: true,
		reason: {
			modules: []
		}
	}

	selections.forEach(selection => {
		const validation = canSelectModuleWithId(moduleId, selection, skipIds)
		if (!validation.valid) {
			validationResult.valid = false
		}

		validationResult.reason.modules = validationResult.reason.modules.concat(validation.reason.modules)
	})
	return validationResult
}

export function canSelectModuleWithId(moduleId: string, selection: { [id: string]: {id: string, content?: string, moduleFields?: { mrIncompatible?: IIncompatibleModule[]}}[]}, skipIds?: string[]) {
	let validationResult: IValidationResult = {
		valid: true,
		reason: {
			modules: []
		}
	}

	for (var key in selection) {
		if (skipIds && skipIds?.includes(key)) // don´t validate against a module in the current step because otherwise an already made selection can´t be changed if it´s other selections of the current step are incompatible with the new selection
			continue
		
		selection[key].forEach(selectedModule => {
			// check if the new module is incompatible with an already made selection
			const incompatibleModuleSelected = selectedModule.moduleFields?.mrIncompatible?.find(incompatibleModule => incompatibleModule.id === moduleId)
			if (incompatibleModuleSelected) {
				validationResult.valid = false
				validationResult.reason.modules.push(selectedModule)
			}
			// check if a selection becomes incompatible after selecting the new module
			const moduleBecomesIncompatible = selectedModule.moduleFields?.mrIncompatible?.find(incompatibleModule => incompatibleModule.id === moduleId)
			if (moduleBecomesIncompatible) {
				validationResult.valid = false
				validationResult.reason.modules.push(selectedModule)
			}
		})
	}
	validationResult.reason.modules = uniqBy(validationResult.reason.modules, "id")
	return validationResult
}


